var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.animationStyle === "bars"
      ? _c(
          "div",
          { staticClass: "spinner", class: _vm.classes ? _vm.classes : "" },
          [
            _c("div", { staticClass: "rect1" }),
            _vm._v(" "),
            _c("div", { staticClass: "rect2" }),
            _vm._v(" "),
            _c("div", { staticClass: "rect3" }),
            _vm._v(" "),
            _c("div", { staticClass: "rect4" }),
            _vm._v(" "),
            _c("div", { staticClass: "rect5" }),
            _vm._v(" "),
            _c("div", { staticClass: "rect6" }),
            _vm._v(" "),
            _c("div", { staticClass: "rect7" }),
            _vm._v(" "),
            _c("div", { staticClass: "rect8" }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.animationStyle === "spinner"
      ? _c("div", [
          _c("i", {
            staticClass: "fa fa-spinner fa-spin",
            class: _vm.classes ? _vm.classes : "",
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }